import { useCallback, useEffect, useMemo, useState } from "react";
import { useQuery } from "@apollo/client";
import mergeOperations from "@magento/peregrine/lib/util/shallowMerge";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import { useCatalogContext } from "@magento/peregrine/lib/context/catalog";
import DEFAULT_OPERATIONS from "./navigation.gql";
const ancestors = {
  CREATE_ACCOUNT: "SIGN_IN",
  FORGOT_PASSWORD: "SIGN_IN",
  MY_ACCOUNT: "MENU",
  SIGN_IN: "MENU",
  MENU: null
};
export const useNavigation = function () {
  let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations);
  const {
    getRootCategoryId
  } = operations;
  // retrieve app state from context
  const [appState, {
    closeDrawer
  }] = useAppContext();
  const [catalogState] = useCatalogContext();
  const {
    data: getRootCategoryData
  } = useQuery(getRootCategoryId, {
    fetchPolicy: "cache-and-network"
  });
  const rootCategoryId = useMemo(() => {
    if (getRootCategoryData) {
      return getRootCategoryData.storeConfig.root_category_id;
    }
  }, [getRootCategoryData]);

  // extract relevant data from app state
  const {
    drawer
  } = appState;
  const isOpen = drawer === "nav";
  const {
    categories
  } = catalogState;

  // get local state
  const [view, setView] = useState("MENU");
  const [categoryId, setCategoryId] = useState(rootCategoryId);
  useEffect(() => {
    // On a fresh render with cold cache set the current category as root
    // once the root category query completes.
    if (rootCategoryId && !categoryId) {
      setCategoryId(rootCategoryId);
    }
  }, [categoryId, rootCategoryId]);

  // define local variables
  const category = categories[categoryId];
  const isTopLevel = categoryId === rootCategoryId;
  const hasModal = view !== "MENU";

  // define handlers
  const handleBack = useCallback(() => {
    const parent = ancestors[view];
    if (parent) {
      setView(parent);
    } else if (category && !isTopLevel) {
      setCategoryId(category.parentId);
    } else {
      closeDrawer();
    }
  }, [category, closeDrawer, isTopLevel, view]);
  const handleClose = useCallback(() => {
    closeDrawer();
  }, [closeDrawer]);
  return {
    handleBack,
    handleClose,
    hasModal,
    isOpen,
    isTopLevel,
    view
  };
};